import React, { useState, useEffect } from "react";
import { Modal } from "@material-ui/core";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import styled, { keyframes } from "styled-components";
import {
  TimeBuffer,
  TranscriptBuffer,
  SettingsDuration,
  ModelType,
  deepgram_modal_type,
  deepgram_redact,
  deepgram_language,
} from "../../../helpers/constants";
import { CustomCheckbox, CustomInputField, StyledMenuItem } from "../../common/FormInputs";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import {
  StyledSelectFormControl,
  StyledDropdownIcon,
} from "../../common/CustomSelect/styles";
import {
  PrimaryCTAButton,
  PrimaryOutlinedCTAButton,
  SecondaryCTAButton,
} from "../../common/Buttons";
import { getErrorMessage } from "../../../helpers/functions";
import CaseService from "../../../services/CaseService";
import { Select, makeStyles } from "@material-ui/core";

const SettingModal = ({
  id,
  modal,
  setModal,
  setRefreshStatus,
  meetingDetail,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  const [buffer, setBuffer] = useState(200);
  const [duration, setDuration] = useState("");
  const [transcriptBuffer, setTranscriptBuffer] = useState("");
  const [mediaType, setMediaType] = useState("");
  const [noise, setNoise] = useState("");
  const [normalise, setNormalise] = useState("");
  const [displayInterimResults, setDisplayInterimResults] = useState("");
  const [temparature, setTemparature] = useState("");
  const [noSthreshold, setNoSthreshold] = useState("");
  const [ratioThreshold, setRatioThreshold] = useState("");
  const [logProbThreshold, setLogProbThreshold] = useState("");
  const [radio, setRadio] = useState("");
  const [timeStamp, setTimeStamp] = useState("");
  const [prompt, setPrompt] = useState("");
  const [beamSize, setBeamSize] = useState("");
  const [bestOf, setBestOf] = useState("");
  const [server, setServer] = useState("");
  const [sleepTime, setSleepTime] = useState(1);
  const [seekStep, setSeekStep] = useState("");
  const [silenceThreshold, setSilenceThreshold] = useState("");
  const [minimumSilence, setMinimumSilence] = useState("");
  const [transcriptionCount, setTranscriptionCount] = useState("");
  const [dgModalType, setDgModalType] = useState("");
  const [dgLanguage, setDgLanguage] = useState("");
  const [dgRedact, setDgRedact] = useState("");
  const [dgUttSplit, setDgUttSplit] = useState("");
  const [dgChannels, setDgChannels] = useState("");
  const [dgCallback, setDgCallback] = useState("");
  const [dgParameters, setDgParameters] = useState([]);
  const [inputFields, setInputFields] = useState([
    { keyword: "", intensifier: "" },
  ]);
  const [utteranceEnd, setUtteranceEnd] = useState("");
  const [endPointing, setEndPointing] = useState("");
  const [audioStyle, setAudioStyle] = useState("");
  const [keepSlience, setKeepSlicence] = useState(100);
  const [response, setResponse] = useState("");
  const [transcriptionInterval, setTranscriptionInterval] = useState("");
  const [bitRate, setBitRate] = useState(2048);
  const [maxReconnect, setMaxReconnect] = useState(10);

  useEffect(() => {
    if (meetingDetail?.caseId) {
      setResponse(meetingDetail);
      setDuration(meetingDetail?.timeInterval);
      setTranscriptionInterval(meetingDetail?.autoRefreshTimeInterval);
      setBuffer(meetingDetail?.bufferTime ? meetingDetail?.bufferTime : 200);
      setTranscriptBuffer(meetingDetail?.stopTranscriptionDelay);
      setTranscriptionCount(meetingDetail.transcriptionProcessingCount);
      setServer(
        meetingDetail?.isLocalTranscriptionServer === 4
          ? 0
          : meetingDetail?.isLocalTranscriptionServer
            ? meetingDetail?.isLocalTranscriptionServer
            : 0,
      );
      setMediaType(
        (meetingDetail?.transcriptionModelParams !== null &&
          Object.keys(meetingDetail?.transcriptionModelParams).length === 0) ||
          meetingDetail.transcriptionModelParams === null
          ? "base.en"
          : meetingDetail.transcriptionModelParams.modelType,
      );
      setAudioStyle(
        meetingDetail.audioEnhancementParams === null ||
          meetingDetail?.audioEnhancementParams?.splitOnSilence
          ? 1
          : meetingDetail.crossExamination
            ? 3
            : meetingDetail?.isLocalTranscriptionServer === 4
              ? 4
              : 2,
      );
      setNoise(
        meetingDetail.audioEnhancementParams
          ? meetingDetail.audioEnhancementParams.noiseCancellation
          : "",
      );
      setNormalise(
        meetingDetail.audioEnhancementParams
          ? meetingDetail.audioEnhancementParams.audioNormalisation
          : "",
      );
      setDisplayInterimResults(
        meetingDetail.audioEnhancementParams
          ? meetingDetail.audioEnhancementParams.displayInterimResults
          : false,
      );
      const mp = meetingDetail.transcriptionModelParams;
      const isEmpty = mp !== null && Object.keys(mp || {}).length === 0;
      const isNull = mp === null;
      setTemparature(isEmpty || isNull ? 0 : mp?.temperature);
      setNoSthreshold(isEmpty || isNull ? 0.6 : mp?.noSpeechThreshold);
      setRatioThreshold(
        isEmpty || isNull ? 2.4 : mp?.compressionRatioThreshold,
      );
      setLogProbThreshold(isEmpty || isNull ? -1 : mp?.logProbThreshold);
      setRadio(isEmpty || isNull ? "" : mp?.conditionOnPreviousText);
      setTimeStamp(isEmpty || isNull ? "" : mp?.wordTimeStamps);
      setPrompt(isEmpty || isNull ? "" : mp?.intialPrompt);
      setBeamSize(isEmpty || isNull ? "" : mp?.beamSize);
      setBestOf(isNull ? "" : mp?.bestOf);
      setSleepTime(meetingDetail?.splitOnSilenceParams?.sleepTime || 1);
      setSeekStep(meetingDetail?.splitOnSilenceParams?.seekStep || 100);
      setSilenceThreshold(
        meetingDetail?.splitOnSilenceParams?.silenceThreshold || -50,
      );
      setMinimumSilence(
        meetingDetail?.splitOnSilenceParams?.minimumSilence || 1,
      );
      setKeepSlicence(meetingDetail?.splitOnSilenceParams?.keepSlience || 100);
      setDgModalType(isEmpty || isNull ? "nova-2-meeting" : mp?.model);
      setDgLanguage(isEmpty || isNull ? "en-GB" : mp?.language);
      setDgUttSplit(isEmpty || isNull ? 0.8 : mp?.utt_split);
      setDgChannels(isEmpty || isNull ? 1 : mp?.channels);
      setDgCallback(isEmpty || isNull ? "" : mp?.callback);
      setDgRedact(isEmpty || isNull ? "" : mp?.redact);
      setUtteranceEnd(isEmpty || isNull ? 2000 : mp?.utterance_end_ms);
      setBitRate(
        !meetingDetail?.liveTranscriptionParams ||
          Object.keys(meetingDetail.liveTranscriptionParams).length === 0
          ? 2048
          : meetingDetail.liveTranscriptionParams.bitRateLimit,
      );
      setMaxReconnect(
        !meetingDetail?.liveTranscriptionParams ||
          Object.keys(meetingDetail.liveTranscriptionParams).length === 0
          ? 10
          : meetingDetail.liveTranscriptionParams.reconnectMaxAttempts,
      );
      setEndPointing(isEmpty || isNull ? 500 : mp?.endpointing);
      if (mp === null || mp !== null) {
        const addParam = (key) => {
          if (mp?.[key]) setDgParameters((p) => [...p, key]);
        };
        [
          "measurements",
          "dictation",
          "diarize",
          "filler_words",
          "numerals",
          "paragraphs",
          "profanity_filter",
          "punctuate",
          "utterances",
          "vad_events",
          "interim_results",
          "smart_format",
        ].forEach(addParam);
        if (isEmpty || isNull) {
          [
            "measurements",
            "diarize",
            "numerals",
            "profanity_filter",
            "punctuate",
            "utterances",
            "vad_events",
            "interim_results",
            "smart_format",
          ].forEach((k) => setDgParameters((p) => [...p, k]));
        }
      }
      if (mp?.keywords) {
        setInputFields(
          mp.keywords.map((kw) => {
            const [word, intensity] = kw.split(":");
            return { keyword: word, intensifier: parseInt(intensity) };
          }),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetingDetail?.caseId]);

  const usePlaceholderStyles = makeStyles(() => ({
    placeholder: { color: COLORS.INPUT_GRAY },
  }));
  const Placeholder = ({ children }) => {
    const classes = usePlaceholderStyles();
    return <div className={classes.placeholder}>{children}</div>;
  };

  const actionsData = [
    {
      text: "Noise Cancellation",
      props: setNoise,
      value: noise,
      checked: noise,
    },
    {
      text: "Normalise Audio",
      props: setNormalise,
      value: normalise,
      checked: normalise,
    },
    {
      text: "Display Interim Results",
      props: setDisplayInterimResults,
      value: displayInterimResults,
      checked: displayInterimResults,
    },
  ];

  const selectAction = [
    {
      text: "Processing Count",
      props: setTranscriptionCount,
      value: transcriptionCount,
      name: transcriptionCount,
      type: "number",
      placeholder: "Count",
    },
    {
      text: "Keep Silence (ms)",
      props: setBuffer,
      value: buffer,
      name: buffer,
      type: "select",
      placeholder: "Buffer time",
      menuItem: TimeBuffer,
    },
    {
      text: "Audio Chunk Duration",
      props: setDuration,
      value: duration,
      name: duration,
      type: "select",
      placeholder: "Duration",
      menuItem: SettingsDuration,
    },
    {
      text: "Stop Transcription Buffer",
      props: setTranscriptBuffer,
      value: transcriptBuffer,
      name: transcriptBuffer,
      type: "select",
      placeholder: "Buffer time",
      menuItem: TranscriptBuffer,
    },
  ];

  const modalAction = [
    {
      props: setTemparature,
      value: temparature,
      name: temparature,
      type: "number",
      label: "Temperature",
    },
    {
      props: setNoSthreshold,
      value: noSthreshold,
      name: noSthreshold,
      type: "number",
      label: "No Speech Threshold",
    },
    {
      props: setRatioThreshold,
      value: ratioThreshold,
      name: ratioThreshold,
      type: "number",
      label: "Compression Ratio",
    },
    {
      props: setLogProbThreshold,
      value: logProbThreshold,
      name: logProbThreshold,
      type: "number",
      label: "LogProb Threshold",
    },
    {
      props: setBeamSize,
      value: beamSize,
      name: beamSize,
      type: "number",
      label: "Beam Size",
    },
    {
      props: setBestOf,
      value: bestOf,
      name: bestOf,
      type: "number",
      label: "Best Of",
    },
  ];

  const radioActions = [
    {
      label: "Condition on previous text",
      props: setRadio,
      value: radio,
      checked: radio,
    },
    {
      label: "Word Timestamps",
      props: setTimeStamp,
      value: timeStamp,
      checked: timeStamp,
    },
  ];

  const audio_style_action = [
    { label: "Live Streaming", value: 4, name: "liveStreaming" },
    { label: "Split on Silence", value: 1 },
    { label: "Periodic Split", value: 2 },
    { label: "Cross Examination", value: 3 },
  ];

  const servers = [
    { label: "JustAct Server 2 (D)", value: 0 },
    { label: "JustAct Server 1 (W)", value: 2 },
  ];

  const split_on_slience = [
    {
      props: setKeepSlicence,
      value: keepSlience,
      name: keepSlience,
      type: "number",
      label: "Keep Silence (ms)",
    },
    {
      props: setSeekStep,
      value: seekStep,
      name: seekStep,
      type: "number",
      label: "Seek Step (ms)",
    },
    {
      props: setSilenceThreshold,
      value: silenceThreshold,
      name: silenceThreshold,
      type: "number",
      label: "Silence Threshold (dB)",
    },
    {
      props: setMinimumSilence,
      value: minimumSilence,
      name: minimumSilence,
      type: "number",
      label: "Min Silence (s)",
    },
    {
      props: setSleepTime,
      value: sleepTime,
      name: sleepTime,
      type: "number",
      label: "Sleep Time (s)",
    },
    {
      props: setTranscriptionCount,
      value: transcriptionCount,
      name: transcriptionCount,
      type: "number",
      label: "Processing Count",
    },
  ];

  const dg_inputs = [
    {
      text: "Model Type",
      props: setDgModalType,
      value: dgModalType,
      name: dgModalType,
      placeholder: "Select model type",
      menuItem: deepgram_modal_type,
      type: "select",
    },
    {
      text: "Language",
      props: setDgLanguage,
      value: dgLanguage,
      name: dgLanguage,
      placeholder: "Select language",
      menuItem: deepgram_language,
      type: "select",
    },
    {
      text: "Redact",
      props: setDgRedact,
      value: dgRedact,
      name: dgRedact,
      placeholder: "Select redact",
      menuItem: deepgram_redact,
      type: "select",
    },
    {
      props: setDgUttSplit,
      value: dgUttSplit,
      name: dgUttSplit,
      type: "number",
      label: "Utt Split (P)",
    },
    {
      props: setDgChannels,
      value: dgChannels,
      name: dgChannels,
      type: "number",
      label: "Channels",
    },
    {
      props: setDgCallback,
      value: dgCallback,
      name: dgCallback,
      type: "text",
      label: "Callback (URL)",
    },
    {
      props: setUtteranceEnd,
      value: utteranceEnd,
      name: utteranceEnd,
      type: "number",
      label: "Utterance End (ms)",
    },
    {
      props: setEndPointing,
      value: endPointing,
      name: endPointing,
      type: "number",
      label: "End Pointing (ms)",
    },
  ];

  const deepgram_parameters = [
    { label: "Measurements (P)", value: "measurements" },
    { label: "Dictation", value: "dictation" },
    { label: "Diarize", value: "diarize" },
    { label: "Filler Words", value: "filler_words" },
    { label: "Numerals", value: "numerals" },
    { label: "Paragraphs (P)", value: "paragraphs" },
    { label: "Profanity Filter", value: "profanity_filter" },
    { label: "Punctuate", value: "punctuate" },
    { label: "Utterances (P)", value: "utterances" },
    { label: "VAD Events (S)", value: "vad_events" },
    { label: "Interim Results", value: "interim_results" },
    { label: "Smart Format", value: "smart_format" },
  ];

  const settings = [
    {
      label: "Auto Refresh Interval",
      name: "autoRefreshTimeInterval",
      type: "text",
      placeholder: "Seconds",
      value: transcriptionInterval,
      setter: setTranscriptionInterval,
    },
    {
      label: "Bit Rate Limit",
      name: "bitRateLimit",
      type: "number",
      placeholder: "kbps",
      value: bitRate,
      setter: setBitRate,
    },
    {
      label: "Max Reconnect Attempts",
      name: "reconnectMaxAttempts",
      type: "number",
      placeholder: "Max attempts",
      value: maxReconnect,
      setter: setMaxReconnect,
    },
  ];

  async function onFormSubmit(caseId) {
    try {
      setLoader({ state: true, message: "Update settings..." });
      const newArray = [];
      await inputFields.forEach((obj) => {
        if (obj.keyword && obj.intensifier)
          newArray.push(`${obj.keyword}:${obj.intensifier}`);
      });
      let filterObj = {
        model: dgModalType,
        language: dgLanguage,
        measurements: dgParameters.includes("measurements"),
        dictation: dgParameters.includes("dictation"),
        diarize: dgParameters.includes("diarize"),
        filler_words: dgParameters.includes("filler_words"),
        numerals: dgParameters.includes("numerals"),
        paragraphs: dgParameters.includes("paragraphs"),
        profanity_filter: dgParameters.includes("profanity_filter"),
        punctuate: dgParameters.includes("punctuate"),
        redact: dgRedact,
        utterances: dgParameters.includes("utterances"),
        vad_events: dgParameters.includes("vad_events"),
        interim_results: dgParameters.includes("interim_results"),
        smart_format: dgParameters.includes("smart_format"),
        utt_split: dgUttSplit,
        channels: dgChannels,
        callback: dgCallback,
        keywords: newArray,
        utterance_end_ms: utteranceEnd,
        endpointing: endPointing,
      };
      for (let key in filterObj) {
        if (!filterObj[key] && filterObj[key] !== 0) delete filterObj[key];
        if (Array.isArray(filterObj[key]) && filterObj[key].length === 0)
          delete filterObj[key];
      }
      const payload = {
        timeInterval: duration,
        autoRefreshTimeInterval: transcriptionInterval,
        bufferTime: audioStyle === 1 ? keepSlience : buffer,
        transcriptionProcessingCount: transcriptionCount,
        stopTranscriptionDelay: transcriptBuffer,
        isLocalTranscriptionServer: audioStyle === 4 ? 4 : server,
        crossExamination: audioStyle === 3,
        audioEnhancementParams: {
          splitOnSilence: audioStyle === 1,
          noiseCancellation: noise,
          audioNormalisation: normalise,
          displayInterimResults,
        },
        transcriptionModelParams:
          server === 0 || server === 4
            ? filterObj
            : {
                modelType: mediaType,
                intialPrompt: prompt,
                conditionOnPreviousText: radio,
                temperature: temparature,
                wordTimeStamps: timeStamp,
                noSpeechThreshold: noSthreshold,
                compressionRatioThreshold: ratioThreshold,
                logProbThreshold,
                beamSize,
                bestOf,
              },
        splitOnSilenceParams: {
          sleepTime,
          seekStep,
          silenceThreshold,
          minimumSilence,
        },
        liveTranscriptionParams: {
          bitRate: bitRate || 2048,
          reconnectMaxAttempts: maxReconnect || 10,
        },
      };
      const res = await CaseService.caseTranscriptionSettings(caseId, payload);
      if (res) enqueueSnackbar(res?.message, { variant: "success" });
      setRefreshStatus(true);
    } catch (error) {
      enqueueSnackbar(getErrorMessage(error), { variant: "error" });
    } finally {
      setLoader({ state: false });
      setModal(false);
    }
  }

  const handleCheckboxChange = (value) =>
    setDgParameters((prev) =>
      prev.includes(value) ? prev.filter((i) => i !== value) : [...prev, value],
    );
  const handleAddFields = () =>
    setInputFields([...inputFields, { keyword: "", intensifier: "" }]);
  const handleInputChange = (index, event) => {
    const vals = [...inputFields];
    vals[index][event.target.name] = event.target.value;
    setInputFields(vals);
  };
  const handleRemoveFields = (index) => {
    const vals = [...inputFields];
    vals.splice(index, 1);
    setInputFields(vals);
  };

  const handleServerChange = (item) => {
    if (item?.value === 0) {
      if (!response?.transcriptionModelParams?.language) setDgLanguage("en-GB");
      [
        "measurements",
        "smart_format",
        "interim_results",
        "vad_events",
        "utterances",
        "punctuate",
        "profanity_filter",
        "numerals",
        "diarize",
      ].forEach((k) => {
        if (!response?.transcriptionModelParams?.[k])
          setDgParameters((p) => [...p, k]);
      });
      if (!response?.transcriptionModelParams?.model)
        setDgModalType("nova-2-meeting");
      if (!response?.transcriptionModelParams?.utt_split) setDgUttSplit(0.8);
      if (!response?.transcriptionModelParams?.channels) setDgChannels(1);
      if (!response?.transcriptionModelParams?.utterance_end_ms)
        setUtteranceEnd(1000);
      if (!response?.transcriptionModelParams?.endpointing) setEndPointing(500);
    } else if (item?.value === 2) {
      if (!response?.transcriptionModelParams?.temperature) setTemparature(0);
      if (!response?.transcriptionModelParams?.noSpeechThreshold)
        setNoSthreshold(0.6);
      if (!response?.transcriptionModelParams?.compressionRatioThreshold)
        setRatioThreshold(2.4);
      if (!response?.transcriptionModelParams?.logProbThreshold)
        setLogProbThreshold(-1);
    }
    if (audioStyle === 4) {
      setAudioStyle("");
      setServer(item.value);
    } else {
      setServer(item.value);
    }
  };

  const handleAudioStyleChange = (item) => {
    if (item.name === "liveStreaming") {
      setServer(0);
      [
        "measurements",
        "smart_format",
        "interim_results",
        "vad_events",
        "utterances",
        "punctuate",
        "profanity_filter",
        "numerals",
        "diarize",
      ].forEach((k) => {
        if (!response?.transcriptionModelParams?.[k])
          setDgParameters((p) => [...p, k]);
      });
      if (!response?.transcriptionModelParams?.language) setDgLanguage("en-GB");
      if (!response?.transcriptionModelParams?.model)
        setDgModalType("nova-2-meeting");
      if (!response?.transcriptionModelParams?.utt_split) setDgUttSplit(0.8);
      if (!response?.transcriptionModelParams?.channels) setDgChannels(1);
      if (!response?.transcriptionModelParams?.utterance_end_ms)
        setUtteranceEnd(1000);
      if (!response?.transcriptionModelParams?.endpointing) setEndPointing(500);
    }
    setAudioStyle(item.value);
  };

  const renderSelect = (action) => (
    <StyledSelectFormControl variant="outlined">
      <Select
        value={action.value}
        name={action.name}
        displayEmpty
        onChange={(e) => action.props(e.target.value)}
        renderValue={
          action.value !== ""
            ? undefined
            : () => <Placeholder>{action.placeholder}</Placeholder>
        }
        IconComponent={() => (
          <StyledDropdownIcon
            alt="select"
            src={require("../../../assets/images/dropdownIcon.svg")}
          />
        )}
      >
        {action.menuItem.map((el, i) => (
          <StyledMenuItem key={i} value={el.value} disabled={el.disabled}>
            {el.label}
          </StyledMenuItem>
        ))}
      </Select>
    </StyledSelectFormControl>
  );

  return (
    <Modal open={modal} onClose={() => setModal(false)} disableRestoreFocus>
      <ModalRoot>
        <ModalShell>
          <ModalHeader>
            <HeaderLeft>
              <ModalTitle>Transcription Settings</ModalTitle>
              <ModalSubtitle>
                Configure audio &amp; model parameters
              </ModalSubtitle>
            </HeaderLeft>
            <CloseBtn type="button" onClick={() => setModal(false)}>
              <img
                src={require("../../../assets/images/closeModal.svg")}
                alt="close"
              />
            </CloseBtn>
          </ModalHeader>
          <ModalBody>
            <Sidebar>
              <SideGroup>
                <GroupLabel>Transcription Server</GroupLabel>
                {servers.map((item) => (
                  <OptionBtn
                    key={item.value}
                    active={item.value === server}
                    type="button"
                    onClick={() => handleServerChange(item)}
                  >
                    <OptionDot active={item.value === server} />
                    <OptionText active={item.value === server}>
                      {item.label}
                    </OptionText>
                  </OptionBtn>
                ))}
              </SideGroup>
              <SideDivider />
              <SideGroup>
                <GroupLabel>Audio Style</GroupLabel>
                {audio_style_action.map((item) => (
                  <OptionBtn
                    key={item.value}
                    active={item.value === audioStyle}
                    type="button"
                    onClick={() => handleAudioStyleChange(item)}
                  >
                    <OptionDot active={item.value === audioStyle} />
                    <OptionText active={item.value === audioStyle}>
                      {item.label}
                    </OptionText>
                  </OptionBtn>
                ))}
              </SideGroup>
              <SideDivider />
              <SideGroup>
                <GroupLabel>Value Added Services</GroupLabel>
                {actionsData.map((item) => (
                  <OptionBtn
                    key={item.text}
                    active={!!item.checked}
                    type="button"
                    onClick={() => item.props(!item.checked)}
                  >
                    <ToggleBox checked={!!item.checked}>
                      {!!item.checked && "✓"}
                    </ToggleBox>
                    <OptionText active={!!item.checked}>{item.text}</OptionText>
                  </OptionBtn>
                ))}
              </SideGroup>
            </Sidebar>
            <ContentArea className="invoice">
              {/* Model Parameters */}
              <Panel>
                <PanelHeader>
                  <PanelDot />
                  <PanelTitle>Model Parameters</PanelTitle>
                </PanelHeader>
                <PanelBody>
                  {server === 1 || server === 2 ? (
                    <>
                      <FieldGrid cols={3}>
                        {modalAction.map((m, i) => (
                          <FieldBlock key={i}>
                            <FieldLabel>{m.label}</FieldLabel>
                            <CustomInputField
                              variant="outlined"
                              name={m.name}
                              type={m.type}
                              value={m.value}
                              onChange={(e) => m.props(e.target.value)}
                            />
                          </FieldBlock>
                        ))}
                        <FieldBlock style={{ gridColumn: "span 2" }}>
                          <FieldLabel>
                            Initial Prompt (comma separated)
                          </FieldLabel>
                          <CustomInputField
                            variant="outlined"
                            name={prompt}
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                          />
                        </FieldBlock>
                        <FieldBlock>
                          <FieldLabel>Model Type</FieldLabel>
                          <StyledSelectFormControl variant="outlined">
                            <Select
                              value={mediaType}
                              name={mediaType}
                              displayEmpty
                              onChange={(e) => setMediaType(e.target.value)}
                              renderValue={
                                mediaType !== ""
                                  ? undefined
                                  : () => (
                                      <Placeholder>
                                        Select Model Type
                                      </Placeholder>
                                    )
                              }
                              IconComponent={() => (
                                <StyledDropdownIcon
                                  alt="select"
                                  src={require("../../../assets/images/dropdownIcon.svg")}
                                />
                              )}
                            >
                              {ModelType.map((item, idx) => (
                                <StyledMenuItem
                                  key={idx}
                                  value={item.value}
                                  disabled={item.disabled}
                                >
                                  {item.label}
                                </StyledMenuItem>
                              ))}
                            </Select>
                          </StyledSelectFormControl>
                        </FieldBlock>
                      </FieldGrid>
                      <FieldGrid cols={2} style={{ marginTop: 9 }}>
                        {radioActions.map((item, i) => (
                          <TogglePill
                            key={i}
                            checked={!!item.checked}
                            as="div"
                            onClick={() => item.props(!item.checked)}
                            style={{ cursor: "pointer" }}
                          >
                            <ToggleBox checked={!!item.checked}>
                              {item.checked ? "✓" : ""}
                            </ToggleBox>
                            <PillText>{item.label}</PillText>
                          </TogglePill>
                        ))}
                      </FieldGrid>
                    </>
                  ) : (
                    <>
                      <FieldGrid cols={3}>
                        {dg_inputs.map((action, i) => (
                          <FieldBlock key={i}>
                            <FieldLabel>
                              {action.text || action.label}
                            </FieldLabel>
                            {action.type === "select" ? (
                              renderSelect(action)
                            ) : (
                              <CustomInputField
                                variant="outlined"
                                name={action.name}
                                value={action.value}
                                type={action.type}
                                onChange={(e) => action.props(e.target.value)}
                              />
                            )}
                          </FieldBlock>
                        ))}
                      </FieldGrid>
                      <SubSection>
                        <SubLabel>Keywords</SubLabel>
                        {inputFields.map((inputField, index) => (
                          <KeywordRow key={index}>
                            <CustomInputField
                              variant="outlined"
                              type="text"
                              name="keyword"
                              value={inputField.keyword}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="Keyword"
                            />
                            <CustomInputField
                              variant="outlined"
                              type="text"
                              name="intensifier"
                              value={inputField.intensifier}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="Intensifier"
                            />
                            <RemoveBtn
                              type="button"
                              onClick={() => handleRemoveFields(index)}
                            >
                              <img
                                src={require("../../../assets/images/removeIcon.svg")}
                                alt="remove"
                              />
                            </RemoveBtn>
                          </KeywordRow>
                        ))}
                        <AddNewBtn onClick={handleAddFields}>
                          + Add New
                        </AddNewBtn>
                      </SubSection>
                      <SubSection>
                        <SubLabel>Deepgram Parameters</SubLabel>
                        <PillWrap>
                          {deepgram_parameters.map((item) => (
                            <TogglePill
                              key={item.value}
                              checked={dgParameters.includes(item.value)}
                              htmlFor={`dg_${item.value}`}
                            >
                              <CustomCheckbox
                                type="checkbox"
                                id={`dg_${item.value}`}
                                checked={dgParameters.includes(item.value)}
                                onChange={() =>
                                  handleCheckboxChange(item.value)
                                }
                                style={{ display: "none" }}
                              />
                              <ToggleBox
                                checked={dgParameters.includes(item.value)}
                              >
                                {dgParameters.includes(item.value) ? "✓" : ""}
                              </ToggleBox>
                              <PillText>{item.label}</PillText>
                            </TogglePill>
                          ))}
                        </PillWrap>
                      </SubSection>
                    </>
                  )}
                </PanelBody>
              </Panel>

              {audioStyle === 1 && (
                <Panel>
                  <PanelHeader>
                    <PanelDot />
                    <PanelTitle>Split on Silence Parameters</PanelTitle>
                  </PanelHeader>
                  <PanelBody>
                    <FieldGrid cols={3}>
                      {split_on_slience.map((m, i) => (
                        <FieldBlock key={i}>
                          <FieldLabel>{m.label}</FieldLabel>
                          <CustomInputField
                            variant="outlined"
                            type={m.type}
                            name={m.name}
                            value={m.value}
                            onChange={(e) => m.props(e.target.value)}
                          />
                        </FieldBlock>
                      ))}
                    </FieldGrid>
                  </PanelBody>
                </Panel>
              )}

              {audioStyle === 2 && (
                <Panel>
                  <PanelHeader>
                    <PanelDot />
                    <PanelTitle>Periodic Split Parameters</PanelTitle>
                  </PanelHeader>
                  <PanelBody>
                    <FieldGrid cols={2}>
                      {selectAction.map((action, i) => (
                        <FieldBlock key={i}>
                          <FieldLabel>{action.text}</FieldLabel>
                          {action.type === "select" ? (
                            renderSelect(action)
                          ) : (
                            <CustomInputField
                              variant="outlined"
                              type={action.type}
                              name={action.name}
                              value={action.value}
                              onChange={(e) => action.props(e.target.value)}
                            />
                          )}
                        </FieldBlock>
                      ))}
                    </FieldGrid>
                  </PanelBody>
                </Panel>
              )}

              <Panel>
                <PanelHeader>
                  <PanelDot />
                  <PanelTitle>Live Transcription Settings</PanelTitle>
                </PanelHeader>
                <PanelBody>
                  <FieldGrid cols={3}>
                    {settings.map(
                      ({ label, name, type, placeholder, value, setter }) => (
                        <FieldBlock key={name}>
                          <FieldLabel>{label}</FieldLabel>
                          <CustomInputField
                            variant="outlined"
                            type={type}
                            name={name}
                            placeholder={placeholder}
                            value={value}
                            onChange={(e) => setter(e.target.value)}
                          />
                        </FieldBlock>
                      ),
                    )}
                  </FieldGrid>
                </PanelBody>
              </Panel>
            </ContentArea>
          </ModalBody>
          <ModalFooter>
            <CancelBtn onClick={() => setModal(false)}>Cancel</CancelBtn>
            <SaveBtn onClick={() => onFormSubmit(id)}>Save Settings</SaveBtn>
          </ModalFooter>
        </ModalShell>
      </ModalRoot>
    </Modal>
  );
};

export default SettingModal;

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.96) translateY(10px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
`;

const ModalRoot = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(8px, 2vw, 20px);
  overflow-y: auto;
`;

const ModalShell = styled.div`
  position: relative;
  width: 100%;
  max-width: min(1260px, 96vw);
  min-width: 0;
  background: #ffffff;
  border-radius: clamp(12px, 1.5vw, 20px);
  box-shadow:
    0 24px 80px rgba(15, 17, 50, 0.22),
    0 4px 16px rgba(15, 17, 50, 0.08);
  outline: none;
  animation: ${fadeIn} 0.3s cubic-bezier(0.22, 1, 0.36, 1) both;
  display: flex;
  flex-direction: column;
  max-height: min(92vh, 800px);
  overflow: hidden;
`;

const ModalHeader = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: clamp(12px, 2vh, 20px) clamp(16px, 2vw, 28px);
  background: linear-gradient(135deg, #1a1d3a 0%, #2d2f6b 58%, #3b3f8c 100%);
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
  flex-wrap: wrap;
`;

const ModalTitle = styled.h3`
  margin: 0;
  font-family: ${theme.fonts.primaryFontExtraBold};
  font-size: clamp(13px, 1.2vw, 17px);
  color: #ffffff;
  letter-spacing: 0.02em;
  white-space: nowrap;
`;

const ModalSubtitle = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: clamp(10px, 0.9vw, 12px);
  color: rgba(255, 255, 255, 0.5);
  white-space: nowrap;
`;

const CloseBtn = styled.button`
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
  img {
    width: 12px;
    height: 12px;
    filter: brightness(0) invert(1);
  }
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const ModalBody = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  overflow: hidden;
  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

const Sidebar = styled.aside`
  flex-shrink: 0;
  width: clamp(155px, 17vw, 205px);
  background: #f8f9fd;
  border-right: 1px solid #eceef6;
  overflow-y: auto;
  overflow-x: hidden;
  padding: clamp(10px, 1.4vh, 16px) 0;
  @media (max-width: 640px) {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 10px 12px;
    border-right: none;
    border-bottom: 1px solid #eceef6;
    overflow-y: visible;
    overflow-x: auto;
  }
`;

const SideGroup = styled.div`
  padding: 0 clamp(8px, 1vw, 13px) clamp(8px, 1.2vh, 14px);
  @media (max-width: 640px) {
    padding: 0 8px 0 0;
    min-width: 130px;
  }
`;

const SideDivider = styled.div`
  height: 1px;
  background: #eceef6;
  margin: 0 12px clamp(6px, 1vh, 12px);
  @media (max-width: 640px) {
    display: none;
  }
`;

const GroupLabel = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 9px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #9095b0;
  margin-bottom: 5px;
  padding: 0 2px;
  white-space: nowrap;
`;

const OptionBtn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 8px;
  border-radius: 8px;
  border: 1.5px solid ${({ active }) => (active ? "#00838c" : "transparent")};
  background: ${({ active }) =>
    active ? "rgba(0,131,140,0.08)" : "transparent"};
  cursor: pointer;
  margin-bottom: 3px;
  transition: all 0.13s;
  text-align: left;
  min-width: 0;
  &:hover {
    border-color: ${({ active }) => (active ? "#00838c" : "#d0d3eb")};
    background: ${({ active }) => (active ? "rgba(0,131,140,0.1)" : "#f0f1f9")};
  }
`;

const OptionDot = styled.div`
  flex-shrink: 0;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 2px solid ${({ active }) => (active ? "#00838c" : "#c0c4d8")};
  background: ${({ active }) => (active ? "#00838c" : "transparent")};
  position: relative;
  transition: all 0.13s;
  &::after {
    content: "";
    position: absolute;
    inset: 2px;
    border-radius: 50%;
    background: #fff;
    opacity: ${({ active }) => (active ? 1 : 0)};
  }
`;

const ToggleBox = styled.div`
  flex-shrink: 0;
  width: 13px;
  height: 13px;
  border-radius: 3px;
  border: 2px solid ${({ checked }) => (checked ? "#00838c" : "#c0c4d8")};
  background: ${({ checked }) => (checked ? "#00838c" : "transparent")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  color: #fff;
  transition: all 0.13s;
`;

const OptionText = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: clamp(10px, 0.85vw, 12px);
  color: ${({ active }) => (active ? COLORS.COLOR_DARK : COLORS.COLOR_DARK)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ContentArea = styled.div`
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: clamp(10px, 1.4vw, 16px) clamp(10px, 1.4vw, 18px);
  display: flex;
  flex-direction: column;
  gap: clamp(8px, 1.2vh, 12px);
`;

const Panel = styled.div`
  border: 1px solid #eceef6;
  border-radius: 10px;
  overflow: hidden;
  flex-shrink: 0;
`;

const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  background: #f8f9fd;
  border-bottom: 1px solid #eceef6;
`;

const PanelDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #00838c;
  flex-shrink: 0;
`;

const PanelTitle = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #567189;
`;

const PanelBody = styled.div`
  padding: clamp(8px, 1.1vh, 12px) clamp(8px, 1vw, 13px);
`;

const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(
      clamp(110px, calc(100% / ${({ cols }) => cols || 2} - 12px), 220px),
      1fr
    )
  );
  gap: 7px 9px;
`;

const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
`;

const FieldLabel = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 10.5px;
  color: #949ab0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const SubSection = styled.div`
  margin-top: 9px;
`;

const SubLabel = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 11px;
  color: ${COLORS.INPUT_LABEL};
  margin-bottom: 5px;
`;

const KeywordRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 28px;
  gap: 7px;
  align-items: center;
  margin-bottom: 5px;
`;

const RemoveBtn = styled.button`
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 1px solid #fcd4d4;
  background: #fff5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.12s;
  img {
    width: 13px;
    height: 13px;
    object-fit: contain;
  }
  &:hover {
    background: #ffe4e4;
  }
`;

const AddNewBtn = styled(SecondaryCTAButton)`
  font-size: 12px !important;
  padding: 4px 11px !important;
  border-radius: 7px !important;
  margin-top: 3px;
`;

const PillWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

const TogglePill = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border-radius: 7px;
  // border: 1.5px solid ${({ checked }) => (checked ? "#00838c" : "#e4e7f3")};
  background: ${({ checked }) =>
    checked ? "rgba(0,131,140,0.07)" : "#fafbff"};
  cursor: pointer;
  transition: all 0.13s;
  user-select: none;
  &:hover {
    border-color: #b0d4d6;
    background: #f0f9fa;
    transform: translateY(-1px);
  }
`;

const PillText = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 13px;
  color: ${COLORS.COLOR_DARK};
  white-space: nowrap;
`;

const ModalFooter = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: clamp(9px, 1.3vh, 13px) clamp(16px, 2vw, 24px);
  border-top: 1px solid #eceef6;
  background: #f8f9fd;
`;

const CancelBtn = styled(PrimaryOutlinedCTAButton)`
  min-width: clamp(90px, 10vw, 120px) !important;
  border-radius: 9px !important;
  font-size: 13px !important;
  font-family: ${theme.fonts.primaryFontSemiBold} !important;
`;

const SaveBtn = styled(PrimaryCTAButton)`
  min-width: clamp(110px, 12vw, 150px) !important;
  border-radius: 9px !important;
  font-size: 13px !important;
  font-family: ${theme.fonts.primaryFontSemiBold} !important;
  transition:
    transform 0.14s,
    box-shadow 0.14s !important;
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 5px 18px rgba(0, 131, 140, 0.3) !important;
  }
`;
